module.exports = __webpack_public_path__ + "img/ani1frame-old.64da4511.png";